import axios from "axios";
import { formatCurrency, formatTicket } from "helpers/helpers";


const API_BASE_URL = `${process.env.REACT_APP_LARAVEL_API_HOST}/api`;
const TOKEN = process.env.REACT_APP_LARAVEL_API_TOKEN;

export async function sendClientEmail(clientData, products) {
  const templateId = "d-f4428ee0c953434caf8ca1420277bc2e";

  const subtotal_price = products.reduce((total, producto) => {
    return total + (producto.price * producto.quantity);
  }, 0);

  const travel_price = subtotal_price > 549.0 ? 0 : 149;

  const orders = products.map(product => {
    return {
      name: product.name,
      quantity: product.quantity,
      variants: product.description,
      price: formatCurrency(product.price * product.quantity),
    }
  });

  const data = {
    ...clientData,
    pedido: formatTicket(clientData.pedido, 5),
    subtotal_price: formatCurrency(subtotal_price),
    travel_price: formatCurrency(travel_price),
    total_price: formatCurrency(subtotal_price + travel_price),
    taxes: formatCurrency(subtotal_price * 0.16),
    orders
  };
  const response = await sendEmail('afinazone@outlook.com', clientData.email, templateId, data);
  return response;
}

export async function sendAfinazoneEmail(clientData, products) {
  const templateId = "d-fa6fbf7dcb424b91970df0cd7516a8e3";
  
  const subtotal_price = products.reduce((total, producto) => {
    return total + (producto.price * producto.quantity);
  }, 0);

  const travel_price = subtotal_price > 549.0 ? 0 : 149;

  const orders = products.map(product => {
    return {
      name: product.name,
      quantity: product.quantity,
      variants: product.description,
      price: formatCurrency(product.price * product.quantity),
    }
  });

  const data = {
    ...clientData,
    pedido: formatTicket(clientData.pedido, 5),
    subtotal_price: formatCurrency(subtotal_price),
    travel_price: formatCurrency(travel_price),
    total_price: formatCurrency(subtotal_price + travel_price),
    taxes: formatCurrency(subtotal_price * 0.16),
    orders
  };

  const response = await sendEmail('auto-tek@outlook.com', 'afinazone@outlook.com', templateId, data);

  return response;
}

export async function sendEmail(fromEmail, toEmail, dynamicTemplateId, dynamicTemplateData) {
  try {
    const data = {
      personalizations: [
        {
          to: [{ email: toEmail }],
          dynamic_template_data: dynamicTemplateData,
        },
      ],
      from: { email: fromEmail },
      template_id: dynamicTemplateId,
    };
   
    const headers = {
      Authorization: `Bearer ${TOKEN}`,
      'Content-Type': 'application/json',
    };

    const response = await axios.post(
      `${API_BASE_URL}/afinazone/email/sendEmail`,
      data,
      { headers }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
